module.exports = __webpack_public_path__ + "static/media/it-never-rains-tablet.409a0cbe.jpg";